
import {
  Mixins, Component,
} from 'vue-property-decorator';
import moment from 'moment';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActivityBox from '@/components/TaskActivityBox.vue';
import TaskActions from '@/components/TaskActions.vue';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import Editor from '@/components/Editor.vue';
import EditLeadCustomerDialog from '@/components/EditLeadCustomerDialog.vue';
import EditLeadSupplyDialog from '@/components/EditLeadSupplyDialog.vue';
import EditLeadOpNumberDialog from '@/components/EditLeadOpNumberDialog.vue';
import EditLeadIbanDialog from '@/components/EditLeadIbanDialog.vue';
import EditLeadIbanConnessioneDialog from '@/components/EditLeadIbanConnessioneDialog.vue';
import EditLeadPodDialog from '@/components/EditLeadPodDialog.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import {
  LeadStatus,
  BoxStatusType,
} from '@/types';
import {
  getLeadCustomValueBoolean,
  getLeadCustomValueText,
  getLeadCustomValueDate,
  seletedLeadHasSupply,
  capitalizeFirst,
} from '@/helpers';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import TaskMixin from '@/mixins/TaskMixin.vue';

@Component({
  components: {
    TaskStatusAlert,
    TaskActivityBox,
    TaskActions,
    Editor,
    EditLeadCustomerDialog,
    EditLeadSupplyDialog,
    EditLeadOpNumberDialog,
    EditLeadIbanDialog,
    EditLeadIbanConnessioneDialog,
    EditLeadPodDialog,
    AttachmentWithStatus,
    SwitchWithConfirm,
    DatePickerDialog,
  },
})
export default class TaskCm extends Mixins(TaskMixin, UtilsMixin) {
  editCustomerDialog = false
  editSupplyDialog = false
  editOpDialog = false
  editIbanDialog = false
  editIbanConnessioneDialog = false
  editPodDialog = false
  datePickerDialog = false
  datePickerDate: string | null = null
  datePickerField: string | null = null

  opTypes = [
    {
      text: '110%',
      value: '110',
    },
    {
      text: 'STD/50%',
      value: '50',
    },
  ]

  opNumber: string | null = null
  opType: string | null = null
  invoiceDiscount: string | null = null
  loan: string | null = null
  // startEmailSent = false
  customerUpdated = false
  notes: string | null | undefined = null

  iban: string | null = null
  ibanConnessione: string | null = null

  pod: string | null = null
  orderConfirmationDate: Date | null = null
  firstPmClientContactDate: Date | null = null

  visuraCatastale: BoxStatusType = 'todo'
  planimetriaCatastale: BoxStatusType = 'todo'
  ultimaBollettaElettrica: BoxStatusType = 'todo'
  documentiIdentita: BoxStatusType = 'todo'

  checkZonaVincolo: BoxStatusType = 'todo'
  checkZonaVincoloLastUpdate: Date | null = null
  checkZonaVincoloUpdater: string | null | undefined = null
  checkZonaVincoloNotes: string | null | undefined = null

  autodichiarazioneCliente: BoxStatusType = 'todo'
  autodichiarazioneClienteNotes: string | null | undefined = null

  checkAccountGSE: BoxStatusType = 'todo'
  checkAccountGSELastUpdate: Date | null = null
  checkAccountGSEUpdater: string | null | undefined = null
  usernameGSE: string | null = null
  passwordGSE: string | null = null

  // installationAddress
  installationToponym: string | null | undefined = null
  installationStreet: string | null | undefined = null
  installationHouseNumber: string | null | undefined = null
  installationPostalCode: string | null | undefined = null
  installationLocation: string | null | undefined = null
  installationProvince: string | null | undefined = null
  installationEmail: string | null | undefined = null
  installationPhone1: string | null | undefined = null
  installationAddressConfirmed = false

  // residentialAddress
  hasInstallationResidence = false
  installationResidenceToponym: string | null | undefined = null
  installationResidenceStreet: string | null | undefined = null
  installationResidenceHouseNumber: string | null | undefined = null
  installationResidencePostalCode: string | null | undefined = null
  installationResidenceLocation: string | null | undefined = null
  installationResidenceProvince: string | null | undefined = null

  checkContoEnergia: string | null = null
  checkContoEnergiaValues = [
    {
      text: 'Da fare',
      value: 'todo',
    },
    {
      text: '1° conto',
      value: 'conto1',
    },
    {
      text: '2° conto',
      value: 'conto2',
    },
    {
      text: '3° conto',
      value: 'conto3',
    },
    {
      text: '4° conto',
      value: 'conto4',
    },
    {
      text: '5° conto',
      value: 'conto5',
    },
    {
      text: 'NO',
      value: 'no',
    },
  ]
  checkAccountGSENotes: string | null | undefined = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.opNumber = this.selectedLead?.opNumber ?? null;
    this.opType = this.selectedLead?.opType ?? null;
    this.invoiceDiscount = getLeadCustomValueText(this.selectedLead, 'invoiceDiscount');
    this.loan = getLeadCustomValueText(this.selectedLead, 'loan');
    // this.startEmailSent = getLeadCustomValueBoolean(this.selectedLead, 'startEmailSent') ?? false;
    this.customerUpdated = getLeadCustomValueBoolean(this.selectedLead, 'customerUpdated') ?? false;
    this.notes = getLeadCustomValueText(this.selectedLead, 'opNotes');

    this.visuraCatastale = (getLeadCustomValueText(this.selectedLead, 'visuraCatastale') ?? 'todo') as BoxStatusType;
    this.planimetriaCatastale = (getLeadCustomValueText(this.selectedLead, 'planimetriaCatastale') ?? 'todo') as BoxStatusType;
    this.ultimaBollettaElettrica = (getLeadCustomValueText(this.selectedLead, 'ultimaBollettaElettrica') ?? 'todo') as BoxStatusType;
    this.documentiIdentita = (getLeadCustomValueText(this.selectedLead, 'documentiIdentita') ?? 'todo') as BoxStatusType;

    this.checkZonaVincolo = (getLeadCustomValueText(this.selectedLead, 'checkZonaVincolo') ?? 'todo') as BoxStatusType;
    this.checkZonaVincoloLastUpdate = getLeadCustomValueDate(this.selectedLead, 'checkZonaVincoloLastUpdate');
    this.checkZonaVincoloUpdater = getLeadCustomValueText(this.selectedLead, 'checkZonaVincoloUpdater');
    this.checkZonaVincoloNotes = getLeadCustomValueText(this.selectedLead, 'checkZonaVincoloNotes');

    this.autodichiarazioneCliente = (getLeadCustomValueText(this.selectedLead, 'autodichiarazioneCliente')
      ?? 'todo') as BoxStatusType;
    this.autodichiarazioneClienteNotes = getLeadCustomValueText(this.selectedLead, 'autodichiarazioneClienteNotes');

    this.checkAccountGSE = (getLeadCustomValueText(this.selectedLead, 'checkAccountGSE') ?? 'todo') as BoxStatusType;
    this.checkAccountGSELastUpdate = getLeadCustomValueDate(this.selectedLead, 'checkAccountGSELastUpdate');
    this.checkAccountGSEUpdater = getLeadCustomValueText(this.selectedLead, 'checkAccountGSEUpdater');
    this.usernameGSE = getLeadCustomValueText(this.selectedLead, 'usernameGSE') ?? null;
    this.passwordGSE = getLeadCustomValueText(this.selectedLead, 'passwordGSE') ?? null;
    this.checkContoEnergia = getLeadCustomValueText(this.selectedLead, 'checkContoEnergia') ?? 'todo';
    this.checkAccountGSENotes = getLeadCustomValueText(this.selectedLead, 'checkAccountGSENotes') ?? null;

    this.iban = getLeadCustomValueText(this.selectedLead, 'iban') ?? null;
    this.ibanConnessione = getLeadCustomValueText(this.selectedLead, 'ibanConnessione') ?? null;

    this.pod = getLeadCustomValueText(this.selectedLead, 'pod') ?? null;
    this.orderConfirmationDate = getLeadCustomValueDate(this.selectedLead, 'orderConfirmationDate');
    this.firstPmClientContactDate = getLeadCustomValueDate(this.selectedLead, 'firstPmClientContactDate');

    // Se non sono presenti dati della bolletta, recupera i dati del contatto
    if (this.selectedLead?.hasInstallation !== true) {
      this.installationToponym = this.selectedLead?.toponimo ?? 'via';
      this.installationStreet = this.selectedLead?.indirizzo ?? null;
      this.installationHouseNumber = this.selectedLead?.civico ?? null;
      this.installationPostalCode = this.selectedLead?.cap ?? null;
      this.installationLocation = this.selectedLead?.citta ?? null;
      this.installationProvince = this.selectedLead?.provincia ?? null;
      this.installationEmail = this.selectedLead?.email ?? null;
      this.installationPhone1 = this.selectedLead?.telefono ?? null;
    } else {
      this.installationToponym = getLeadCustomValueText(this.selectedLead, 'installationToponym') ?? 'via';
      this.installationStreet = getLeadCustomValueText(this.selectedLead, 'installationStreet') ?? null;
      this.installationHouseNumber = getLeadCustomValueText(this.selectedLead, 'installationHouseNumber') ?? null;
      this.installationPostalCode = getLeadCustomValueText(this.selectedLead, 'installationPostalCode') ?? null;
      this.installationLocation = this.selectedLead?.installationLocation ?? null;
      this.installationProvince = this.selectedLead?.installationProvince ?? null;
      this.installationEmail = getLeadCustomValueText(this.selectedLead, 'installationEmail') ?? null;
      this.installationPhone1 = getLeadCustomValueText(this.selectedLead, 'installationPhone1') ?? null;
    }

    // residentialAddress
    this.hasInstallationResidence = getLeadCustomValueBoolean(this.selectedLead, 'hasInstallationResidence') ?? false;
    this.installationResidenceToponym = getLeadCustomValueText(this.selectedLead, 'installationResidenceToponym') ?? 'via';
    this.installationResidenceStreet = getLeadCustomValueText(this.selectedLead, 'installationResidenceStreet') ?? null;
    this.installationResidenceHouseNumber = getLeadCustomValueText(this.selectedLead, 'installationResidenceHouseNumber') ?? null;
    this.installationResidencePostalCode = getLeadCustomValueText(this.selectedLead, 'installationResidencePostalCode') ?? null;
    this.installationResidenceLocation = getLeadCustomValueText(this.selectedLead, 'installationResidenceLocation') ?? null;
    this.installationResidenceProvince = getLeadCustomValueText(this.selectedLead, 'installationResidenceProvince') ?? null;
    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  // Installazione
  get installationAddress() {
    let result = '';

    if (this.installationStreet) {
      if (this.installationToponym) result += `${capitalizeFirst(this.installationToponym)} `;
      if (this.installationStreet) result += `${this.installationStreet} `;
      if (this.installationHouseNumber) result += `${this.installationHouseNumber} `;
      result += '<br>';
    }
    if (this.installationPostalCode) result += `${this.installationPostalCode} `;
    if (this.installationLocation) result += `${this.installationLocation} `;
    if (this.installationProvince) result += `(${this.installationProvince.toUpperCase()})`;

    return result;
  }

  get installationResidenceAddress() {
    if (this.hasInstallationResidence !== true) {
      return 'Indirizzo di residenza coincide con l\'indirizzo della fornitura';
    }

    let result = '';

    if (this.installationResidenceStreet) {
      if (this.installationResidenceToponym) result += `${capitalizeFirst(this.installationResidenceToponym)} `;
      if (this.installationResidenceStreet) result += `${this.installationResidenceStreet} `;
      if (this.installationResidenceHouseNumber) result += `${this.installationResidenceHouseNumber} `;
      result += '<br>';
    }
    if (this.installationResidencePostalCode) result += `${this.installationResidencePostalCode} `;
    if (this.installationResidenceLocation) result += `${this.installationResidenceLocation} `;
    if (this.installationResidenceProvince) result += `(${this.installationResidenceProvince.toUpperCase()})`;

    return result;
  }

  // I dati extra sono validi?
  get isExtraDataValid(): boolean {
    // Le attività sono da fare o in attesa
    if (this.visuraCatastale === 'todo' || this.visuraCatastale === 'waiting') return false;
    if (this.planimetriaCatastale === 'todo' || this.planimetriaCatastale === 'waiting') return false;
    if (this.ultimaBollettaElettrica === 'todo' || this.ultimaBollettaElettrica === 'waiting') return false;
    if (this.documentiIdentita === 'todo' || this.documentiIdentita === 'waiting') return false;

    // Le attività sono completate ma manca l'allegato
    if (this.visuraCatastale === 'done' && !this.hasAttachments('visuraCatastale')) return false;
    if (this.planimetriaCatastale === 'done' && !this.hasAttachments('planimetriaCatastale')) return false;
    if (this.ultimaBollettaElettrica === 'done' && !this.hasAttachments('ultimaBollettaElettrica')) return false;
    if (this.documentiIdentita === 'done' && !this.hasAttachments('documentiIdentita')) return false;

    // In tutti gli altri casi...
    return true;
  }

  get leadOpType(): string | null {
    return this.selectedLead?.opType ?? null;
  }

  get leadStatus(): LeadStatus | null { return this.selectedLead?.status ?? null; }

  get opTypeLong(): string | null {
    switch (this.leadOpType) {
      case '110':
        return '110%';

      case '50':
        return 'STD/50%';

      default:
        break;
    }

    return null;
  }

  get hasSupply(): boolean {
    return seletedLeadHasSupply();
  }

  // Mostra le azioni nell'Alert soltanto sulle lead figlie e sui Task senza figlie
  get showAlertActions(): boolean { return this.task?.relationship !== 'father'; }

  // Mostra le azioni
  get showActions(): boolean { return !this.task && !this.readonly && !this.embedded; }

  podAlert(pod: string | null) {
    // ritorna true se il codice POD inizia con la stringa it002e
    return pod !== null ? pod.replace(/ /g, '').toLowerCase().startsWith('it002e') || false : false;
  }

  get ibanRequiredRules() {
    return this.ibanRules(this.iban);
  }

  get ibanConnessioneRequiredRules() {
    return this.ibanRules(this.ibanConnessione);
  }

  get podRequiredRules() {
    return this.podRules(this.pod);
  }

  get checkZonaVincoloTooltip(): string | null | undefined {
    return this.checkZonaVincoloLastUpdate
      ? `Ultima modifica: ${moment(this.checkZonaVincoloLastUpdate).format('L')} ore ${moment(this.checkZonaVincoloLastUpdate).format('LT')} (${this.checkZonaVincoloUpdater})`
      : 'Nessuna modifica effettuata';
  }

  get checkAccountGSETooltip(): string | null | undefined {
    return this.checkAccountGSELastUpdate
      ? `Ultima modifica: ${moment(this.checkAccountGSELastUpdate).format('L')} ore ${moment(this.checkAccountGSELastUpdate).format('LT')} (${this.checkAccountGSEUpdater})`
      : 'Nessuna modifica effettuata';
  }

  get checkAccountGSEClass(): string | null | undefined {
    return this.checkAccountGSE === 'na' ? 'mb-5' : null;
  }

  get orderConfirmationDateFormatted(): string {
    return this.orderConfirmationDate && moment(this.orderConfirmationDate).isValid()
      ? moment(this.orderConfirmationDate).format('L')
      : '';
  }

  get firstPmClientContactDateFormatted(): string {
    return this.firstPmClientContactDate && moment(this.firstPmClientContactDate).isValid()
      ? moment(this.firstPmClientContactDate).format('L')
      : '';
  }

  get fieldsDisabled(): boolean {
    return (
      this.selectedTask?.status !== null
      && !this.hasPermission('completedTaskCm.edit')
    )
      || this.readonly
      || this.loading
      || this.updating;
  }

  // FIXME: Utilizzare quello del Mixin ma integrare le eccezioni
  onFieldUpdated(field: string) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    const update = {} as { [key: string]: unknown };

    // Aggiorna sempre il campo specificato
    update[field] = this[field] ?? '';

    // Aggiorna eventuali campi collegati, eccezioni, ecc.
    switch (field) {
      case 'invoiceDiscount':
      case 'loan':
        update[field] = this[field] ?? null;
        break;

      case 'orderConfirmationDate':
        update[field] = this[field];
        break;

      case 'firstPmClientContactDate':
        update[field] = this[field];
        break;

      default:
        break;
    }

    this.$store.dispatch('updateTaskFields', update);
  }

  onEditOpNotes() {
    console.log(`${this.constructor.name}: onEditOpNotes()`); // eslint-disable-line no-console

    this.$emit('goto', 'opNotes');
  }

  onEditCustomer() {
    this.editCustomerDialog = true;
  }

  onEditSupply() {
    this.editSupplyDialog = true;
  }

  async onEditOp() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.editOpDialog = true;
  }

  async onEditIban() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.editIbanDialog = true;
  }

  async onEditIbanConnessione() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.editIbanConnessioneDialog = true;
  }

  async onEditPod() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.editPodDialog = true;
  }

  onClickOrderConfirmationDate() {
    console.log(`${this.constructor.name}: onClickOrderConfirmationDate()`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open'
      || this.taskStatus !== null
      || this.readonly) return;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this.orderConfirmationDate
      ? moment(this.orderConfirmationDate).toISOString(true).substring(0, 10)
      : null;

    // Imposta il campo da aggiornare
    this.datePickerField = 'orderConfirmationDate';

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  onClearOrderConfirmationDate() {
    console.log(`${this.constructor.name}: onClearOrderConfirmationDate()`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    this.orderConfirmationDate = null;
    update.orderConfirmationDate = null;

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onSelectDate(date: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date =`, date); // eslint-disable-line no-console

    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    const update = {} as { [key: string]: unknown };

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerField === 'firstPmClientContactDate') {
      this.firstPmClientContactDate = selectedDate;
      update.firstPmClientContactDate = this.firstPmClientContactDate;
    } else if (this.datePickerField === 'orderConfirmationDate') {
      this.orderConfirmationDate = selectedDate;
      update.orderConfirmationDate = this.orderConfirmationDate;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  async onEditOrderConfirmationDate() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.onClickOrderConfirmationDate();
  }

  onClickFirstPmClientContactDate() {
    console.log(`${this.constructor.name}: onClickFirstPmClientContactDate()`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open'
      || this.taskStatus !== null
      || this.readonly) return;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this.firstPmClientContactDate
      ? moment(this.firstPmClientContactDate).toISOString(true).substring(0, 10)
      : null;

    // Imposta il campo da aggiornare
    this.datePickerField = 'firstPmClientContactDate';

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  onClearFirstPmClientContactDate() {
    console.log(`${this.constructor.name}: onClearFirstPmClientContactDate()`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    this.firstPmClientContactDate = null;
    update.firstPmClientContactDate = null;

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  async onEditFirstPmClientContactDate() {
    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario
    await this.$store.dispatch('selectTask', {
      name: 'Cm',
      leadId: this.selectedLead?.id,
      unselectLeadOnClose: false,
    });

    this.onClickFirstPmClientContactDate();
  }

  updateBoxStatus(name: string, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateBoxStatus(${name}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non esiste si ferma subito
    if (name in this === false) { return; }

    this[name] = status;

    const update = {} as { [key: string]: unknown };

    if (name === 'checkZonaVincolo') {
      this.checkZonaVincoloLastUpdate = new Date();
      update.checkZonaVincoloLastUpdate = this.checkZonaVincoloLastUpdate;

      this.checkZonaVincoloUpdater = this.$store.getters.currentUser.name;
      update.checkZonaVincoloUpdater = this.checkZonaVincoloUpdater;
    }

    if (name === 'checkAccountGSE') {
      this.checkAccountGSELastUpdate = new Date();
      update.checkAccountGSELastUpdate = this.checkAccountGSELastUpdate;

      this.checkAccountGSEUpdater = this.$store.getters.currentUser.name;
      update.checkAccountGSEUpdater = this.checkAccountGSEUpdater;
    }

    update[name] = status;

    this.$store.dispatch('updateTaskFields', update);
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }
}
